import React, {
  useCallback,
  useEffect,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';
import {
  useParams,
  useNavigate,
} from 'react-router-dom';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  getUiState,
} from 'web-selectors';

import {
  Spinner,
  NotFound,
  EventResults,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

const EventResultsPage = () => {
  const params = useParams();
  const id = +params.id;
  const resourceType = 'workoutEvents';
  const mapState = useCallback(state => ({
    readStatus: getStatus(
      state,
      [
        `${resourceType}.requests.fetchFullEvent.status`,
        `${resourceType}.meta[${id}].readStatus`,
      ],
      true,
    ),
    changeStatus: getStatus(
      state,
      [
        'exerciseResults.requests.createResultItems.status',
        'exerciseResults.requests.removeAllResults.status',
      ],
    ),
    finishStatus: getStatus(
      state,
      ['workoutEvents.requests.finishEvent.status'],
    ),
    event: coreSelectors.getCurrentEvent(resourceType, id)(state),
    exercises: coreSelectors.getAllEventExercises(id)(state),
    namespace: getUiState('namespace')(state),
  }), [id]);
  const {
    event,
    exercises,
    namespace,
    readStatus,
    changeStatus,
    finishStatus,
  } = useSelector(mapState, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(coreActions.requestLoadFullWorkoutEvent({
      id,
    }));
  }, [id]);

  const handleFinished = () => {
    dispatch(
      coreActions.requestFinishEvent(
        event.id,
        {
          onSuccess: () => {
            navigate('/welcome');
          },
        },
      ),
    );
  };

  const handleRemoveAll = () => {
    const onConfirmAction = coreActions.requestRemoveAllEventResults(
      event.id,
    );

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Remove All results?',
          bodyText: 'Are you sure you want remove all results?',
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <Flex fillSpace>
      {readStatus.succeeded && (
        <EventResults
          event={event}
          exercises={exercises}
          namespace={namespace}
          onFinished={handleFinished}
          onRemoveAll={handleRemoveAll}
        />
      )}

      {(changeStatus.pending || finishStatus.pending) && (
        <Spinner over message="Plase wait..." />
      )}

      {readStatus.pending && (
        <Spinner message="Loading Event..." />
      )}

      {readStatus.failed && (
        <NotFound title={`Event Not Found (${id})`} />
      )}
    </Flex>
  );
};

export default EventResultsPage;
